export default __webpack_public_path__ + "static/orangeloop-34-c70fb00e9afe9322a5ea322e246893fd.jpg";